import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Async from 'react-select/async';
import * as selectors from '../../reducers';
import Inside from 'turf-inside';
import styles from './geo-search-input.module.scss';

// QLD coordinates
const bbox = [137.994324998, -29.1778977, 153.552171248, -9.14217597699997];
const token =
  'pk.eyJ1Ijoic21hbGxtdWx0aXBsZXMiLCJhIjoiRk4xSUp6OCJ9.GilBdBaV0oKMZgBwBqRMWA';
const baseUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/{text}.json?country=au&bbox=${bbox}&access_token=${token}`;
const getUrl = (text) => {
  return baseUrl.replace('{text}', text.replace(/\s/g, '+'));
};

const Option = (props) => {
  const { innerProps, label, value, getStyles } = props;

  return (
    <div
      style={{
        ...getStyles('option', props),
        display: 'flex',
        justifyContent: 'space-between',
        padding: 10,
        cursor: 'pointer',
      }}
      className={styles.option}
      {...innerProps}
    >
      <span>{label}</span>
      <span className={styles.optionCouncil}>
        {value.council.properties.name}
        <img
          style={{
            height: 15,
            width: 10,
            marginLeft: 5,
          }}
          alt="Right chevron"
          src={process.env.PUBLIC_URL + '/img/chevron-right-icon.svg'}
        />
      </span>
    </div>
  );
};

class GeoSearchInput extends Component {
  constructor() {
    super();
    this.state = {
      selectedCouncil: null,
    };
    this.getOptions = this.getOptions.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(d) {
    const { onCouncilSelect } = this.props;
    if (!d) return;
    const council = d.value.council;
    // todo
    const selectedCouncilId =
      council && council.properties
        ? d.council.properties['LGA_NAME_2016']
        : null;
    this.setState({ selectedCouncil: d });
    onCouncilSelect(selectedCouncilId);
  }

  getCouncil(d) {
    const { councilsGeo } = this.props;
    if (d && d.geometry) {
      return councilsGeo.features.find((council) => {
        return council.geometry ? Inside(d, council) : false;
      });
    }
  }

  getOptions(text) {
    if (!text || text.length < 2) {
      return Promise.resolve([]);
    }
    const url = getUrl(text);
    return fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const options = data.features
          .filter(
            (d) =>
              d.context.find((d) => d.short_code === 'AU-QLD') &&
              this.getCouncil(d)
          )

          .map((d) => {
            const council = this.getCouncil(d);
            return {
              value: { geo: d, council },
              label: d.place_name.replace(', Australia', ''),
              council: this.getCouncil(d),
            };
          });
        return options;
      });
  }

  filterOptions(options) {
    return options;
  }

  renderInput() {
    const { selectedCouncil } = this.state;
    return (
      <Async
        components={{ Option }}
        loadOptions={this.getOptions}
        value={selectedCouncil}
        onChange={this.handleOnChange}
        isLoading={true}
        defaultOptions={[]}
        placeholder={'Search by address'}
        filterOptions={this.filterOptions}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#28336E',
          },
        })}
      />
    );
  }

  render() {
    return (
      <div className={styles.geoSearchInputWrapper}>
        {this.renderInput()}
        <div className={styles.geoSearchInputImageWrapper}>
          <img
            className={styles.geoSearchInputImage}
            src={`${process.env.PUBLIC_URL}/img/search-icon.svg`}
            alt="search icon"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  councilsGeo: selectors.getQldCouncilsGeo(state),
});

GeoSearchInput.propTypes = {
  onCouncilSelect: PropTypes.func,
  councilsGeo: PropTypes.object,
};

export default connect(mapStateToProps, null)(GeoSearchInput);



// WEBPACK FOOTER //
// ./src/components/geo-search-input/geo-search-input.js